import { render } from "./ModalIncidence_subcategories.vue?vue&type=template&id=758c9a1a"
import script from "./ModalIncidence_subcategories.vue?vue&type=script&lang=js"
export * from "./ModalIncidence_subcategories.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__